export const NodeStatus = {
  READY: 'READY',
  FINISHED: 'FINISHED',
  ABORT: 'ABORT',
  ERROR: 'ERROR',
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
};

export function getNodeIconByStatus(task) {
  let i = parseInt(task);
  if (i % 6 === 0) {
    return 'fa fa-circle-o';
  } else if (i % 6 === 1) {
    return 'fa fa-circle';
  } else if (i % 6 === 2) {
    return 'fa fa-circle';
  } else if (i % 6 === 3) {
    return 'fa fa-circle';
  } else if (i % 6 === 4) {
    return 'fa fa-circle';
  } else if (i % 6 === 5) {
    return 'fa fa-spinner';
  }
}

export function getNodeColorByStatus(task) {
  let i = parseInt(task);
  if (i % 6 === 0) {
    return 'green';
  } else if (i % 6 === 1) {
    return 'green';
  } else if (i % 6 === 2) {
    return 'orange';
  } else if (i % 6 === 3) {
    return 'red';
  } else if (i % 6 === 4) {
    return 'gray';
  } else if (i % 6 === 5) {
    return 'blue';
  }
}
